export default __webpack_public_path__ + "static/media/marketplace-1.684b8e1b.png";